import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import CompanyDetails from '../features/companies/pages/CompanyDetails';
import Filings from '../features/filings/pages/Filings';
import Changelog from '../features/changelog/pages/Changelog';
import Objections from '../features/objections/pages/Objections';
import Companies from '../features/companies/pages/Companies';
import Analytics from '../features/analytics/pages/Analytics';
import Assistants from '../features/assistants/pages/Assistants';
import AssistantResearcher from '../features/assistants/pages/AssistantResearcher';
import Answers from '../features/answers/pages/Answers';
import FilingDetails from '../features/filings/pages/FilingDetails';
import CompetitorFilingsAlerts from '../features/filings/pages/Alerts';
import SecFilingTable from '../features/sec-filings/pages/SecFilingTable';
import SecFilingTracker from '../features/sec-filings/pages/SecFilingTracker';
import GeoInsights from '../features/geo/pages/GeoInsights';
import GeoPrompts from '../features/geo/pages/GeoPrompts';
import { GEO_ROUTES } from '../features/geo/utils/geoConstants';
import ObjectionDetails from '../features/objections/pages/ObjectionDetails';
import Login from '../features/auth/pages/Login';
import NexusView from '../features/nexus/pages/NexusView';
import NexusPulse from '../features/nexus/pages/NexusPulse';
import MarketingTable from '../features/marketing/pages/MarketingTable';
import MarketingAdDetails from '../features/marketing/pages/MarketingAdDetails';
import NewsPrTable from '../features/news-pr/pages/NewsPrTable';
import NewsPrDetails from '../features/news-pr/pages/NewsPrDetails';

const withMainLayout = (page) => <MainLayout>{page}</MainLayout>;

const Documents = () => withMainLayout(<div className="content"><h1>Documents</h1></div>);
const Scheduler = () => withMainLayout(<div className="content"><h1>Scheduler</h1></div>);
const Alerts = () => withMainLayout(<div className="content"><h1>Email Alerts</h1></div>);
const RunHistory = () => withMainLayout(<div className="content"><h1>Run History</h1></div>);
const Filters = () => withMainLayout(<div className="content"><h1>States & Filters</h1></div>);
const Smtp = () => withMainLayout(<div className="content"><h1>SMTP Config</h1></div>);

export const appRoutes = [
  <Route key="login" path="/login" element={<Login />} />,
  <Route key="dashboard" path="/" element={<Navigate to="/competitors?tab=Insights" replace />} />,
  <Route key="companies" path="/all-companies" element={withMainLayout(<Companies />)} />,
  <Route key="company-details" path="/all-companies/company-details/:companyName" element={withMainLayout(<CompanyDetails />)} />,
  <Route key="analytics" path="/analytics" element={withMainLayout(<Analytics />)} />,
  <Route key="filings" path="/filings" element={withMainLayout(<Filings />)} />,
  <Route key="our-filings" path="/our-filings" element={withMainLayout(<Filings />)} />,
  <Route key="rival-filings" path="/rival-filings" element={withMainLayout(<Filings />)} />,
  <Route key="competitors" path="/competitors" element={withMainLayout(<Filings />)} />,
  <Route key="competitor-filings-alerts" path="/competitors/alerts" element={withMainLayout(<CompetitorFilingsAlerts />)} />,
  <Route key="nexus-root" path="/nexus" element={<Navigate to="/nexus/view" replace />} />,
  <Route key="nexus-view" path="/nexus/view" element={withMainLayout(<NexusView />)} />,
  <Route key="nexus-table-redirect" path="/nexus/table" element={<Navigate to="/nexus/pulse" replace />} />,
  <Route key="nexus-pulse" path="/nexus/pulse" element={withMainLayout(<NexusPulse />)} />,
  <Route key="marketing-ad-id" path="/marketing/:platform/:id" element={withMainLayout(<MarketingAdDetails />)} />,
  <Route key="marketing-root" path="/marketing" element={withMainLayout(<MarketingTable />)} />,
  <Route key="marketing-linkedin" path="/marketing/linkedin" element={withMainLayout(<MarketingTable />)} />,
  <Route key="marketing-meta" path="/marketing/meta" element={withMainLayout(<MarketingTable />)} />,
  <Route key="marketing-google" path="/marketing/google" element={withMainLayout(<MarketingTable />)} />,
  <Route key="news-pr" path="/news-pr" element={withMainLayout(<NewsPrTable />)} />,
  <Route key="news-pr-id" path="/news-pr/:id" element={withMainLayout(<NewsPrDetails />)} />,
  <Route key="sec-filing" path="/sec-filing" element={<Navigate to="/sec-filing/insights" replace />} />,
  <Route key="sec-filing-insights" path="/sec-filing/insights" element={withMainLayout(<SecFilingTracker />)} />,
  <Route key="sec-filing-table" path="/sec-filing/table" element={withMainLayout(<SecFilingTable />)} />,
  <Route key="geo-analytics" path={GEO_ROUTES.root} element={<Navigate to={GEO_ROUTES.insights} replace />} />,
  <Route key="geo-analytics-insights" path={GEO_ROUTES.insights} element={withMainLayout(<GeoInsights />)} />,
  <Route key="geo-analytics-prompts" path={GEO_ROUTES.prompts} element={withMainLayout(<GeoPrompts />)} />,
  <Route key="changelog" path="/changelog" element={withMainLayout(<Changelog />)} />,
  <Route key="objections" path="/objections" element={withMainLayout(<Objections />)} />,
  <Route key="documents" path="/documents" element={<Documents />} />,
  <Route key="scheduler" path="/scheduler" element={<Scheduler />} />,
  <Route key="alerts" path="/alerts" element={<Alerts />} />,
  <Route key="run-history" path="/run-history" element={<RunHistory />} />,
  <Route key="filters" path="/filters" element={<Filters />} />,
  <Route key="smtp" path="/smtp" element={<Smtp />} />,
  <Route key="answers" path="/answers" element={withMainLayout(<Answers />)} />,
  <Route key="answers-chat-redirect" path="/answers/chat" element={<Navigate to="/answers" replace />} />,
  <Route key="answers-copy-redirect" path="/answers/copy" element={<Navigate to="/answers" replace />} />,
  <Route key="assistants" path="/assistants" element={<Assistants />} />,
  <Route key="deep-researcher-competitor" path="/deep-researcher-competitor" element={<AssistantResearcher />} />,
  <Route key="competitor-web-researcher" path="/competitor-web-researcher" element={<AssistantResearcher />} />,
  <Route key="state-laws-regulation-deep-search" path="/state-laws-regulation-deep-search" element={<AssistantResearcher />} />,
  <Route key="doi-researcher-deep-search" path="/doi-researcher-deep-search" element={<AssistantResearcher />} />,
  <Route key="jobs-agent" path="/jobs-agent" element={<AssistantResearcher />} />,
  <Route key="filing-id" path="/filing/:id" element={<FilingDetails />} />,
  <Route key="filings-id" path="/filings/:id" element={<FilingDetails />} />,
  <Route key="objections-id" path="/objections/:id" element={<ObjectionDetails />} />,
];
